import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';

export const Button = styled(animated.button)<{ $isActive: boolean }>`
    ${({ theme, $isActive }) => css`
        width: 1.45rem;
        height: 0.375rem;
        border: none;
        display: block;
        cursor: pointer;

        ${$isActive &&
        css`
            background: ${theme.colors.interactive.hex} !important;
        `}
    `}
`;
